var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "grey lighten-5 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-navigation-drawer",
            {
              attrs: {
                temporary: _vm.isMobilePort,
                "mobile-breakpoint": 600,
                app: "",
                clipped: "",
                width: _vm.isMobilePort ? "100%" : 360,
              },
              model: {
                value: _vm.filterDrawer,
                callback: function ($$v) {
                  _vm.filterDrawer = $$v
                },
                expression: "filterDrawer",
              },
            },
            [
              _c("filters", {
                attrs: {
                  filters: _vm.filters,
                  userProfileType: _vm.userProfileType,
                  "default-filters": _vm.activeFilters,
                  "apply-instant-filters": !_vm.isMobilePort,
                },
                on: {
                  close: function ($event) {
                    _vm.filterDrawer = false
                  },
                  "apply-filters": _vm.applyFilters,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "outlined-except-top-left",
                  attrs: { flat: "" },
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "content-container",
                      class: !_vm.isMobilePort ? "px-6" : "",
                      attrs: { fluid: "" },
                    },
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "8" } },
                            [
                              _c(
                                "h2",
                                { staticClass: "text-h4 font-weight-medium" },
                                [_vm._v("Notes and Bookmarks")]
                              ),
                              _vm._v(" "),
                              _c("share-feedback"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex",
                              class: {
                                "d-flex justify-end": !_vm.isMobilePort,
                              },
                              attrs: { cols: "12", md: "4" },
                            },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: { "offset-y": "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: { outlined: "" },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                "\n                                        Actions\n                                        "
                                              ),
                                              _c(
                                                "v-icon",
                                                { staticClass: "ml-1" },
                                                [_vm._v("mdi-chevron-down")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    [
                                      _c(
                                        "v-list-item",
                                        {
                                          attrs: {
                                            href: _vm.getRoute(
                                              "dashboard_my_tags"
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            { staticClass: "mr-3" },
                                            [
                                              _c("v-icon", [
                                                _vm._v("mdi-label-outline"),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-item-title", [
                                            _vm._v("Manage Tags"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "v-btn primary v-btn--flat v-btn--outlined theme--dark v-size--default",
                                  attrs: {
                                    href: _vm.getNotesPrintUrl(),
                                    target: "_blank",
                                  },
                                  on: { click: _vm.onPrintClick },
                                },
                                [
                                  _vm._v(
                                    "\n                                Print (" +
                                      _vm._s(_vm.pagination.total) +
                                      " sections)\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-container",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isLoading,
                      expression: "!isLoading",
                    },
                  ],
                  staticClass: "content-container container-height",
                  class: !_vm.isMobilePort ? "px-5" : "",
                  attrs: { fluid: "" },
                },
                [
                  _c(
                    "v-overlay",
                    { attrs: { value: _vm.isLoading, absolute: "" } },
                    [
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "", size: "64" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { align: "center", justify: "space-between" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: _vm.isMobilePort ? 12 : 6 } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-center justify-space-between w-100",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c(
                                    "h3",
                                    { staticClass: "mb-0 font-weight-medium" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Showing " +
                                            _vm._s(_vm.contentSections.length) +
                                            " of " +
                                            _vm._s(_vm.pagination.total) +
                                            " sections"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "ml-2 text--secondary" },
                                    [
                                      _vm._v(
                                        "(" +
                                          _vm._s(_vm.getTotalNotesBookmarks) +
                                          " notes)"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          class: {
                            "d-flex justify-end": !_vm.isMobilePort,
                          },
                          attrs: { cols: _vm.isMobilePort ? 12 : 6 },
                        },
                        [
                          _vm.isMobilePort
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "mb-5",
                                  attrs: { block: "", outlined: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.filterDrawer = true
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { left: "" } }, [
                                    _vm._v("mdi-filter-variant"),
                                  ]),
                                  _vm._v(
                                    "\n                                Filters\n                        "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-select", {
                            class: _vm.isMobilePort ? "mb-5" : "",
                            style: {
                              maxWidth: _vm.isMobilePort ? "100%" : "250px",
                            },
                            attrs: {
                              items: _vm.sortOptions,
                              "item-text": "text",
                              "item-value": "value",
                              label: "Sort by",
                              block: _vm.isMobilePort,
                              dense: "",
                              "hide-details": "",
                              outlined: "",
                              "menu-props": { bottom: true, offsetY: true },
                            },
                            on: { change: _vm.triggerSortingChange },
                            model: {
                              value: _vm.selectedSort,
                              callback: function ($$v) {
                                _vm.selectedSort = $$v
                              },
                              expression: "selectedSort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("active-filter-chips", {
                    staticClass: "mb-6",
                    attrs: {
                      "is-loading": _vm.isLoading,
                      filters: _vm.filters,
                      "active-filters": _vm.activeFilters,
                    },
                    on: {
                      "clear-group": _vm.clearGroupFilter,
                      "remove-single-filter": _vm.removeSingleFilter,
                    },
                  }),
                  _vm._v(" "),
                  _c("default-content-section-controller", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.contentSections.length,
                        expression: "contentSections.length",
                      },
                    ],
                    attrs: {
                      highlightType: "add-note",
                      "content-sections": _vm.contentSections,
                      "is-notes-section-expanded": true,
                    },
                    on: {
                      sectionSortOrderChanged: _vm.sectionSortOrderChanged,
                    },
                  }),
                  _vm._v(" "),
                  !_vm.isLoading && !_vm.contentSections.length
                    ? _c(
                        "v-row",
                        { attrs: { justify: "center" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "text-center",
                              attrs: { cols: "12", sm: "4" },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: { large: "", color: "primaryMedium" },
                                },
                                [_vm._v("mdi-bookmark-multiple-outline")]
                              ),
                              _vm._v(" "),
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "text-h6 font-weight-medium mt-2",
                                },
                                [_vm._v("No notes or bookmarks found here")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-body-1 text--secondary mt-2",
                                },
                                [
                                  _vm._v(
                                    "\n                            Try clearing your filters. Or try bookmarking sections and adding notes to get started.\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mt-2",
                                  attrs: {
                                    outlined: "",
                                    color: "primary",
                                    href: "https://support.iccsafe.org/ht_kb/digital-codes/how-to-create-notes/",
                                    target: "_blank",
                                  },
                                },
                                [_vm._v("Learn About Notes")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isLoading
                ? _c(
                    "v-container",
                    {
                      staticClass: "content-container container-height",
                      attrs: { fluid: "" },
                    },
                    [
                      _c("loading", [
                        _c(
                          "span",
                          { staticClass: "text-h6 font-weight-medium" },
                          [_vm._v("Loading your notes...")]
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.contentSections.length < _vm.pagination.total
                ? _c(
                    "v-container",
                    { staticClass: "content-container", attrs: { fluid: "" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "text-center",
                          staticStyle: { width: "100%" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                loading: _vm.isMoreLoading,
                                color: "primary",
                              },
                              on: { click: _vm.loadMore },
                            },
                            [
                              _vm._v(
                                "\n                        Show next " +
                                  _vm._s(_vm.showNext) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }